import React from 'react';
import { Outlet } from 'react-router-dom';

function AbleCRMLayout() {
  return (
    <div className="px-8 py-8 max-w-[1400px] mx-auto">
      <Outlet />
    </div>
  );
}

export default AbleCRMLayout;
